import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const IST = 'Asia/Kolkata';

// Always render in Asia/Kolkata regardless of the viewing browser/OS timezone —
// this is an Indian market trading app, times must be IST for everyone, everywhere.
// Drop-in replacement for the plain `dayjs` import used across the app.
const dayjsIST = (...args) => dayjs(...args).tz(IST);
dayjsIST.extend = (...args) => dayjs.extend(...args);

export default dayjsIST;
